export class FetchLastUpdatedDate {
  static readonly type = '[Reporting] Fetch Last Updated Date';
}
